
import io from 'socket.io-client';
import { CLOSE_SOCKET, CREATE_SOCKET, NOTIFICATION_FROM_SOCKET, SHOW_CHAT_NOTIFICATIONS } from '../constants/actionTypes';
import { store } from '../store';

export const createSocket = ({name = 'socket', cb, onConnect}) => async (dispatch) => {

    let res = null;
    let error = null; 

    try {

        //check socket of same name isn't already created
        if(store.getState().socketsReducer[name]){

            console.warn(`**********Socket ${name} already exists`);

            if(typeof cb === 'function'){

                cb({message: `Socket ${name} already exists`}, null); 
            }

            return; 
        }


        const connectionOptions = {
            "force new connection": true,
            reconnectionAttempts: "Infinity",
            //timeout: 10000,
            //transports: ["websocket"], //when this is enabled - connections fail
            autoconnect: true
        };

        let port = window.location.port.length > 0 ? ':'+window.location.port : ''; 
        let socket = io(`${window.location.host === 'localhost:3000' ? 'http://localhost:3000' : process.env.REACT_APP_API_BASE_URL}`, connectionOptions); //set this to api hostname in prod
        //const socket =  io();  
        //socket.connect(); 

        console.log('window location protocol: ', `${window.location.host === 'localhost:3000' ? 'http://localhost:3000' : process.env.REACT_APP_API_BASE_URL}`);

        socket.on('connect', () => {
            console.log('socket connected to server');

            //handle handshake
            if(typeof onConnect === 'function'){

                onConnect(socket);
            }

        });

        socket.on('disconnect', (reason, description) => {
            console.log('socket disconnected, reason: ', reason, ' description: ', description);
        });

        socket.on('notification', async (message) => { //without the async, it disconnects silently. Real reason is parse error. 
            console.log('Notification: ', message);

            if(typeof message === 'object'){

                dispatch({
                    type: NOTIFICATION_FROM_SOCKET,
                    data: message
                });


                //dispatch ui notification to popup for a few seconds
                


            }
        }); 
        
        socket.on('chatNotification', async (message) => { //without the async, it disconnects silently. Real reason is parse error. 
            console.log('ChatNotification: ', message);

            if(typeof message === 'object'){

                dispatch({
                    type: SHOW_CHAT_NOTIFICATIONS,
                    notification: message.chatNotification
                });


                //dispatch ui notification to popup for a few seconds
                


            }
        });

        socket.on('chatMessage', async (message) => { //without the async, it disconnects silently. Real reason is parse error. 
            console.log('ChatMessage: ', message);

            // if(typeof message === 'object'){

            //     dispatch({
            //         type: NOTIFICATION_FROM_SOCKET,
            //         data: message
            //     });


            //     //dispatch ui notification to popup for a few seconds
                


            // }
        });

        dispatch({
            type: CREATE_SOCKET,
            name,
            socket
        });

        res = {
            name,
            socket
        }

    } catch (err) {

        console.warn(err); 
        error = err; 
    }

    if(typeof cb === 'function'){

        cb(error, res);
    }
}

export const closeSocket = (name = 'socket', cb) => async (dispatch) => {

    let res = null;
    let error = null; 

    try {

        let socket = store.getState().socketsReducer[name];

        console.log('Web socket being closed? ');
        if (socket.readyState === 1) { // <-- This is important
            socket.close(); //close the socket
        }  
        
        dispatch({
            type: CLOSE_SOCKET,
            name
        });

    } catch (err) {

        console.warn(err); 
    }
}